import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as RiCheckMark } from '@/assets/icons/ri-checkmark-line.svg';
import { checkWeekday } from '@/utils';

const DATEPICKER_COLOR = {
	BOOKING_EVENT: 'bg-purple-subtle border-purple-secondary text-purple-secondary',
	BOOKING: 'bg-green-subtle border-green-success text-green-success',
	CLOSED_SCHEDULE: 'bg-red-subtle border-red-secondary text-red-secondary',
	PROGRAM: 'bg-blue-subtle border-blue-light text-blue-light',
};
const Timebox = ({
	court,
	hour,
	selectedSchedules = {},
	selectedDate,
	selectedField,
	conflictingSchedules,
	bookedHour,
	setSelectedSchedules,
	setSelectedField,
	setConflictingSchedules,
	prices = {},
	bookingType = '',
	displayOnly,
	holiday = false,
	hideEmptyPrice = false
}: TimeboxProps) => {
	const [isActive, setIsActive] = useState(false);
	const navigate = useNavigate()
	const bookingExists = bookedHour?.schedules?.find(
		(schedule) => schedule.hour === hour
	);
	const priceHour = ((): any => {
		const courtPrice = holiday ?
			prices?.details?.filter(
				(priceList) =>
					priceList.day_type === 'HOLIDAY'
			) :
			prices?.details?.filter(
				(priceList) =>
					priceList.type === bookingType &&
					priceList.day_type === checkWeekday(selectedDate)
			) || [];
		const { price } =
			courtPrice.find(
				(rentPrice) =>
					hour >= rentPrice.start_time && hour <= rentPrice.end_time
			) || {};

		return price;
	})(); 

	let timeboxBgColor = bookingExists
		? `${DATEPICKER_COLOR[bookingExists.type]}`
		: '';
	if (isActive) {
		timeboxBgColor = 'flex justify-center items-center bg-red-primary';
	}
	if (hideEmptyPrice && priceHour === undefined) {
		timeboxBgColor = 'flex justify-center items-center bg-grey-soft';
	}
	
	const isTimeboxSelected = () =>
		selectedSchedules[selectedDate]?.find(
			(schedule) =>
				schedule.court.id === court.id &&
				schedule.hour === hour &&
				schedule.selectedDate === selectedDate
		);

	useEffect(() => {
		if (isTimeboxSelected()) {
			setIsActive(true);
			return;
		}
		setIsActive(false);
	}, [selectedDate]);
	useEffect(() => {
		if (displayOnly) {
			return;
		}
		const newSchedule = {
			court,
			hour,
			selectedDate,
			price: priceHour,
		};
		if (selectedField.includes(court.id)) {
			if (bookingExists) {
				setConflictingSchedules([...conflictingSchedules, newSchedule]);
			}
			setIsActive(true);
			if (!isTimeboxSelected()) {
				const scheduledDate = selectedSchedules[selectedDate] || [];
				const payload = [...scheduledDate, newSchedule];
				const sched = { ...selectedSchedules };
				sched[selectedDate] = payload;
				setSelectedSchedules(sched);
			}
		} else {
			if (isTimeboxSelected()) {
				setIsActive(true);
				return;
			}
			if (bookingExists) {
				if (isActive) {
					setConflictingSchedules(
						conflictingSchedules.filter(
							(conflicts) =>
								conflicts.hour !== newSchedule.hour ||
								conflicts.court.id !== newSchedule.court.id ||
								conflicts.selectedDate !== newSchedule.selectedDate
						)
					);
				}
			}
			setIsActive(false);
		}
	}, [selectedField, selectedSchedules]);
	return (
		<div
			className={`flex flex-col flex-grow items-start p-2 pb-0 h-12 border border-grey-line-subtle ${timeboxBgColor}`}
			key={hour}
			role="button"
			tabIndex={0}
			onClick={() => {
				if (hideEmptyPrice && priceHour === undefined) {
					return;
				}
				if (displayOnly && bookingExists && (bookingExists?.type === 'BOOKING' || bookingExists?.type === 'BOOKING_EVENT'  || bookingExists?.type === 'PROGRAM' )) {
					navigate(bookingExists?.type === 'PROGRAM' ? 
					`/dashboard/programs/edit/${bookingExists?.eventId}` : 
					`/dashboard/booking/${bookingExists?.eventId}/edit`);
					return;
				}
				const newSchedule = {
					court,
					hour,
					selectedDate,
					price: priceHour,
				};
				const scheduledDate = selectedSchedules[selectedDate] || [];
				const payload = isActive
					? scheduledDate?.filter(
							(schedule) =>
								schedule.court.id !== court.id ||
								schedule.hour !== newSchedule.hour ||
								schedule.selectedDate !== newSchedule.selectedDate
					  )
					: [...scheduledDate, newSchedule];
				const sched = { ...selectedSchedules };
				sched[selectedDate] = payload;
				setSelectedSchedules(sched);
				setIsActive(!isActive);
				if (bookingExists) {
					if (isActive) {
						setConflictingSchedules(
							conflictingSchedules.filter(
								(conflicts) =>
									conflicts.hour !== newSchedule.hour ||
									conflicts.court.id !== newSchedule.court.id ||
									conflicts.selectedDate !== newSchedule.selectedDate
							)
						);
					} else {
						setConflictingSchedules([...conflictingSchedules, newSchedule]);
					}
				}
				if (selectedField.includes(court.id)) {
					setSelectedField(selectedField.filter((field) => field !== court.id));
				}
			}}
			onKeyDown={() => {}}
		>
			{!isActive && (
				<div className="overflow-hidden">
					<p className="font-bold text-sm">
						{bookingExists?.type?.toUpperCase()}
					</p>
					<p className="text-xs">{bookingExists?.detail}</p>
				</div>
			)}
			{isActive && <div className="text-white">
				<RiCheckMark />
			</div>}
		</div>
	);
};

export default Timebox;
